import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService, BuroService } from 'src/app/_services';
import { saveAs } from 'file-saver';
import * as ExcelJS from 'exceljs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-reporte-buro',
  templateUrl: './reporte-buro.component.html',
  styleUrls: ['./reporte-buro.component.scss']
})
export class ReporteBuroComponent implements OnInit {
  eventSource: EventSource | undefined;

  processCompleted = -1

  datosBC = null
  fecha_inicio = null
  fecha_final = null
  downloading = false
  downloadingAcuse = false
  control_consulta_downloading = ''
  acuse_downloading = ''
  loading = false
  estados = [
    { id: 'CDMX', valor: 'Ciudad de México', estado: 'Ciudad de México'},
    { id: 'AGS', valor: 'Aguascalientes', estado: 'Aguascalientes'},
    { id: 'BCN', valor: 'Baja California', estado: 'Baja California'},
    { id: 'BCS', valor: 'Baja California Sur', estado: 'Baja California Sur'},
    { id: 'CAM', valor: 'Campeche', estado: 'Campeche' },
    { id: 'CHS', valor: 'Chiapas', estado: 'Chiapas' },
    { id: 'CHI', valor: 'Chihuahua', estado: 'Chihuahua' },
    { id: 'COA', valor: 'Coahuila', estado: 'Coahuila' },
    { id: 'COL', valor: 'Colima', estado: 'Colima' },
    { id: 'DGO', valor: 'Durango', estado: 'Durango' },
    { id: 'EM', valor: 'Estado de México', estado: 'Estado de México' },
    { id: 'GTO', valor: 'Guanajuato', estado: 'Guanajuato' },
    { id: 'GRO', valor: 'Guerrero', estado: 'Guerrero' },
    { id: 'HGO', valor: 'Hidalgo', estado: 'Hidalgo' },
    { id: 'JAL', valor: 'Jalisco', estado: 'Jalisco' },
    { id: 'MICH', valor: 'Michoacán', estado: 'Michoacán' },
    { id: 'MOR', valor: 'Morelos', estado: 'Morelos' },
    { id: 'NAY', valor: 'Nayarit', estado: 'Nayarit' },
    { id: 'NL', valor: 'Nuevo León', estado: 'Nuevo León' },
    { id: 'OAX', valor: 'Oaxaca', estado: 'Oaxaca' },
    { id: 'PUE', valor: 'Puebla', estado: 'Puebla' },
    { id: 'QRO', valor: 'Querétaro', estado: 'Querétaro' },
    { id: 'QR', valor: 'Quintana Roo', estado: 'Quintana Roo' },
    { id: 'SLP', valor: 'San Luis Potosí', estado: 'San Luis Potosí' },
    { id: 'SIN', valor: 'Sinaloa', estado: 'Sinaloa' },
    { id: 'SON', valor: 'Sonora', estado: 'Sonora' },
    { id: 'TAB', valor: 'Tabasco', estado: 'Tabasco' },
    { id: 'TAM', valor: 'Tamaulipas', estado: 'Tamaulipas' },
    { id: 'TLAX', valor: 'Tlaxcala', estado: 'Tlaxcala' },
    { id: 'VER', valor: 'Veracruz', estado: 'Veracruz' },
    { id: 'YUC', valor: 'Yucatán', estado: 'Yucatán' },
    { id: 'ZAC', valor: 'Zacatecas', estado: 'Zacatecas' }
  ];
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private buroService: BuroService,

  ) { }

  ngOnInit(): void {
    this.getTableBC()
  }

  async getTableBC() {
    
    const datosTabla = await this.buroService.consultaReporteBC(this.fecha_inicio, this.fecha_final)
    
 
        this.datosBC = datosTabla;
  
        this.datosBC.forEach((obj) => {
         if(obj.raw != ''){ try {
            let rawJSON = JSON.parse(obj.raw);
            obj.raw = rawJSON;
          } catch (error) {
            console.error('Error parsing raw JSON:', error);
          }}
        });
        const datosfiltrados = this.datosBC.filter((reporte => reporte?.raw))
        this.datosBC = datosfiltrados

  }
  getEstado(estado) {
    const result = this.estados.find(e => e.estado === estado);
  
    if (result) {
      return result.id;
    } else {
      return estado;
    }
  }
   procesarTexto(texto) {
    texto = texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  
    texto = texto.replace(/ñ/g, "n");
  
    texto = texto.toUpperCase();
  
    return texto;
  }
   procesarObjeto(row) {
    for (let clave in row) {
      if (typeof row[clave] === 'string') {
        row[clave] = this.procesarTexto(row[clave]);
      } else if (typeof row[clave] === 'object') {
        row[clave] = this.procesarObjeto(row[clave]);
      }
    }
  
    return row;
  }
  formatearFecha(fecha) {
    const newFecha = new Date(fecha);
    const fechaFormateada = newFecha.toLocaleDateString("es-MX", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
    return fechaFormateada.replace(/\//g, '');
  }

  async resetBC(){
    this.fecha_final = null;
    this.fecha_inicio = null;
   
    this.getTableBC()
  }

  exportToExcel(tableId: string, filename: string) {
    const table = document.getElementById(tableId);
    const rows = Array.from(table.querySelectorAll('tr'));
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');
  
    rows.forEach(row => {
      const rowData = Array.from(row.querySelectorAll('td, th')).map(cell => cell.textContent);
      worksheet.addRow(rowData);
    });
  
    workbook.xlsx.writeBuffer().then(buffer => {
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename + '.xlsx';
      link.click();
      window.URL.revokeObjectURL(url);
    });
  }

  async DescargarPDF({mongo_reference, rfc, control_consulta, referencia_operador}) {
    this.control_consulta_downloading = control_consulta
    this.downloading = true
    const pdf: any = await this.buroService.DescargarPDF({mongo_reference, referencia_operador})
    saveAs('data:application/octet-stream;base64,' + pdf.data, `consulta_buro_${control_consulta}_${rfc}.pdf`)

    this.control_consulta_downloading = ''
    this.downloading = false
  }
  async DescargarPDFAcuseBuro({mongo_reference, rfc, control_consulta, referencia_operador}) {
    this.acuse_downloading = control_consulta
    this.downloadingAcuse = true
    const pdf: any = await this.buroService.DescargarPDFAcuseBuro({mongo_reference, referencia_operador})
    saveAs('data:application/octet-stream;base64,' + pdf.data, `AcuseBuro_${rfc}.pdf`)
    this.acuse_downloading = ''
    this.downloadingAcuse = false
  }


  async exportReporteToExcel() {
    this.loading = true;
    this.processCompleted = -1
   try { 
      this.eventSource = new EventSource(`${environment.config.apiUrl}arcus/reporte_buro_pm`);

      this.eventSource.addEventListener('message', (event: MessageEvent) => {
        const message = JSON.parse(event.data);
        this.processCompleted = message.completed || 1
        
        if (message.statusCode == 200) {
          this.processCompleted = 100
          this.eventSource.close()
          this.loading = false
          this.descargarReporte(message)
        }
      });

      this.eventSource.addEventListener('error', (errorEvent: Event) => {
        console.error('Error in SSE connection', errorEvent);
        this.eventSource.close()
        this.loading = false
      });

    
    } catch(error){
      if (error.message === 'Tiempo de espera agotado') {
        console.error('La solicitud ha excedido el tiempo de espera.');
    } else {
        console.error('Error en la solicitud:', error);
    }

    this.loading = false;
    }
  }

  descargarReporte(res) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');

    worksheet.addRow(['', 'Institucion', 'Inst. Ant', 'Tipo Institucion', 'Formato', 'Fecha', 'Periodo', 'Usuario']);
    worksheet.addRow(['HD', '00', '01', '02', '03', '04', '05', '07']);
    worksheet.addRow(['BNCPM', '6905', '', '002', '1', '30092023', '092023', 'PRODUFIN']);
    worksheet.addRow(['Identificador', 'RFC', 'Codigo Ciudadano', 'Numero Dun', 'Compañía', 'Nombre 1', 'Nombre 2', 'Paterno', 'Materno', 'Nacionalidad', 'Calificacion Banco de Mex.', 'Banxico 1', 'Banxico 2', 'Banxico 3', 'Direccion 1', 'Direccion 2', 'Colonia/Poblacion', 'Delegacion/Municipio', 'Ciudad', 'Estado', 'C.P.', 'Telefono', 'Extension', 'Fax', 'Tipo Cliente', 'Estado extranjero', 'Pais', 'Clave de Cosolidación', 'Identificador', 'RFC Accionista', 'Codigo Ciudadano', 'Numero Dun', 'Nombre Cia.', 'Nombre 1', 'Nombre 2', 'Paterno', 'Materno', 'Porcentaje', 'Direccion 1', 'Direccion 2', 'Colonia/Población', 'Delegación/Municipio', 'Ciudad', 'Estado', 'C.P.', 'Telefono', 'Extension', 'Fax', 'Tipo Cliente', 'Estado extranjero', 'Pais', 'Identificador', 'RFC Empresa', 'Numero Experiencias', 'Contrato', 'Contrato Anterior', 'Fecha Apertura', 'Plazo en meses', 'Tipo de Credito', 'Saldo Inicial', 'Moneda', 'Numero Pagos', 'Frecuencia de Pagos', 'Importe de Pagos', 'Fecha Ultimo Pago', 'Fecha Reestructura', 'Pago en efectivo', 'Fecha Liquidacion', 'Quita', 'Dacion', 'Quebranto', 'Observaciones', 'Especiales', 'Fecha Primer Incum', 'Saldo Insoluto', 'Crédito Máximo Utilizado', 'Fecha de Ingreso a cartera vencida', 'Identificador', 'RFC Empresa', 'Contrato', 'Dias Vencimiento', 'Cantidad', 'Interes', 'Identificador', 'RFC Aval', 'Codigo Ciudadano', 'Numero Dun', 'Nombre Cia.', 'Nombre 1', 'Nombre 2', 'Paterno', 'Materno', 'Direccion 1', 'Direccion 2', 'Colonia/Población', 'Delegación/Municipio', 'Ciudad', 'Estado', 'C.P.', 'Telefono', 'Extension', 'Fax', 'Tipo Cliente', 'Estado extranjero', 'Pais', 'Identificador', 'Numero de Compañias', 'Cantidad']);
    worksheet.addRow(['EM', '00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', 'AC', '00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', 'CR', '00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', 'DE', '00', '01', '02', '03', '04', 'AV', '00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', 'TS', '00', '01']);
    
    for (const row of res.data) {
      this.procesarObjeto(row)
      const nombres = row.EM.tipoPersona === 2 ? (row.EM?.nombres?.split(' ') ?? ['', '']) : ['', ''];
      const nombresAC = row.EM.tipoPersona == 1 && row.AC.tipoPersona === 2 ? (row.AC?.nombres?.split(' ') ?? ['', '']) : ['', ''];
      const nombresAV =  row.AV?.nombres?.split(' ') ?? ['', ''];
      // const getEstado = this.getEstado(row.AC.estado)

      worksheet.addRow(['EM', row.EM.rfc, '', '', row.EM.tipoPersona == 1 ? row.EM.nombreRS : '', nombres[0] ?? '', nombres[1] ?? '', row.EM.apellidoPaterno, row.EM.apellidoMaterno, 'MX', '', '', '', '', row.EM.direccion1, '', row.EM.colonia, row.EM.municipio, row.EM.ciudad, row.EM.estado != null ? this.getEstado(row.EM.estado) : '', `'${row.EM.codigoPostal}`, '', '', '', row.EM.tipoPersona, '', 'MX', '', row.EM.tipoPersona == 1 ? 'AC' : '', row.EM.tipoPersona == 1 ? row.AC.rfc : '', '', '', row.EM.tipoPersona == 1 && row.AC.tipoPersona == 1 ?  row.AC.nombreRS : '' , nombresAC[0] ?? '', nombresAC[1] ?? '', row.EM.tipoPersona == 1 && row.AC.tipoPersona == 2 ? row.AC.apellidoPaterno : '',row.EM.tipoPersona == 1 && row.AC.tipoPersona == 2 ? row.AC.apellidoMaterno : '', '', row.EM.tipoPersona == 1 ? row.AC.direccion1 : '', '', row.EM.tipoPersona == 1 ? row.AC.colonia : '', row.EM.tipoPersona == 1 ? row.AC.municipio : '', row.EM.tipoPersona == 1 ? row.AC.ciudad : '', row.EM.tipoPersona == 1 && row.AC.estado != null ? this.getEstado(row.AC.estado) : '', row.EM.tipoPersona == 1 ? row.AC.codigoPostal : '', '', '', '', row.EM.tipoPersona == 1 ? row.AC.tipoPersona : '' , '', row.EM.tipoPersona == 1 ? 'MX' : '', 'CR', row.EM.rfc, '', row.CR.idAnexo, '', row.CR.fechaApertura != null || row.CR.fechaApertura != '' ? this.formatearFecha(row.CR.fechaApertura) : '', row.CR.plazo ? row.CR.plazo.toFixed(2) : '', '1300',row.CR.saldoInicial!= null ? Math.round(row.CR.saldoInicial) : '', '1', row.CR.numeroPagos, '30', row.CR.importePagos != null ? Math.round(row.CR.importePagos) : '', row.CR.fechaUltimoPago != null || row.CR.fechaUltimoPago != '' ? this.formatearFecha(row.CR.fechaUltimoPago) : '', '', '', row.CR.fechaLiquidacion != null && row.CR.fechaLiquidacion != '' ? this.formatearFecha(row.CR.fechaLiquidacion) : '', '', '', '', row.CR.observaciones, '', '', row.CR.saldoInsoluto != null ? Math.round(row.CR.saldoInsoluto) : '', row.CR.creditoMax != null ? Math.round(row.CR.creditoMax) : '', '', 'DE', row.DE.rfc, row.CR.idAnexo, '', row.DE.cantidad != null ? Math.round(row.DE.cantidad) : '', '', 'AV',  row.AV.rfc, '', '', row.AV.tipoPersona == 1 ? row.AV.nombreRS : '', nombresAV[0] ?? '', nombresAV[1] ?? '', row.AV.apellidoPaterno, row.AV.apellidoMaterno,  row.AV.direccion1, '',  row.AV.colonia, row.AV.municipio,  row.AV.ciudad, row.AV.estado != null ? this.getEstado(row.AV.estado) : '' , row.AV.codigoPostal , '', '', '', row.AV.tipoPersona, '', 'MX' ])//'TS', '00', '01']);
    }
    
    workbook.xlsx.writeBuffer().then(buffer => {
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download =  'reporte_buro_pm.xlsx';
      link.click();
      window.URL.revokeObjectURL(url);
    });
    this.loading = false;
  }
  
  
  logout() {
    this.authenticationService.logout();
    this.router.navigate(['/login']);
  }

}
